export const MAX_LENGTH_EMAIL = 200;
export const MAX_LENGTH_INPUT = 150;
export const MAX_LENGTH_JOB_DESCRIPTION = 10000;
export const MAX_LENGTH_EMPLOYER_NOTE = 5000;
export const MIN_LENGTH_PASSWORD = 6;
export const MAX_LENGTH_COMPANY_DESCRIPTION= 10000;